// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";
import {changeOwed} from "../../WorkIssuanceOwed/owedSlice";
import EmojiFlagsIcon from "@mui/icons-material/EmojiFlags";
import PanToolIcon from "@mui/icons-material/PanTool";
import PaidIcon from "@mui/icons-material/Paid";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import {changeWorkIssuance} from "../../workIssuanceSlice";


// main function
export default function RejectOwed({ onMenuClose, rowCdpStatus, showOwed, showExpense }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************

    const handleReject = () => {
        // dispatchData(changeOwed({rejectedState: true, owedNewStatus: 'Rejected'}));
        dispatchData(changeWorkIssuance({newStatus:  '2042', updateCdpStatus: true}));
        onMenuClose();
    };

    return (

        <Box>
            {(
                    rowCdpStatus === "2040"
                ) &&
                <MenuItem onClick={handleReject}>
                    <ListItemIcon>
                        <ThumbDownOffAltIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Reject</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
